// extracted by mini-css-extract-plugin
export default {"account_banner_wrapper":"gs","float_image":"hs","body":"is","account_banner_title":"js","account_banner_subtitle":"ks","account_banner_text":"ls","account_banner_title_image_wrapper":"ms","title_image":"ns"};
    if(module.hot) {
      // 1715632474908
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  